// extracted by mini-css-extract-plugin
export default {"banner":"r7f32","banner__content":"kNJRr","banner__actions":"CAuQB","banner__legal":"f3ghv"};